import { useEffect, useState } from 'react'

import { useUserInteractions } from '@mc/visibility'
import { StickyControlled } from '@mc/design-system'

import { CSR } from 'components/CSR/CSR'

import { FloatingAction } from './FloatingAction'
import { useConciergeExperience } from '../hooks'
import { FabProvider, useFab } from './FabProvider'
import { trackConciergeViewedorDismissed } from '../events'
import { isConciergeExperienceAlreadyViewed } from '../helpers'

// This FAB should be displayed if:
// * User in on any variant of the experiment
// * User is on any page that has the sticky footer
// * When user has been on page for 6 seconds, has scrolled, and hasn't interacted with any components (useUserInteractions behavior)
// * User is not at the top of the page or User is not at the bottom of the page
export const ConciergeExperienceExperiment = () => {
  const { isVariant } = useConciergeExperience()

  if (!isVariant) return null

  return (
    <CSR>
      <ConciergeExperience />
    </CSR>
  )
}

const ConciergeExperience = () => {
  const [meetUserInteractionCondition, setMeetUserInteractionCondition] =
    useState(isConciergeExperienceAlreadyViewed())

  useUserInteractions({
    timedActions: () => {
      setMeetUserInteractionCondition(true)
    },
    enableConditionFn: () => isConciergeExperienceAlreadyViewed(),
  })

  if (!meetUserInteractionCondition) return null

  return (
    <FabProvider>
      <FloatingContent />
    </FabProvider>
  )
}

const DEFAULT_STICKY_FOOTER_OFFSET_DESKTOP = 98
const DEFAULT_STICKY_FOOTER_OFFSET_MOBILE = 110

const FloatingContent = () => {
  const { showFab, setShowFab, isOpened } = useFab()

  useEffect(() => {
    const bottomBuffer = 580 // From DS sticky footer

    const handleScroll = () => {
      const topOfPage = window.scrollY <= 65
      const footerInView =
        window.scrollY + window.innerHeight >
        document.body.offsetHeight - bottomBuffer

      const shouldShowFab = !topOfPage && !footerInView
      if (shouldShowFab !== showFab) {
        setShowFab(shouldShowFab)
        if (isOpened) {
          trackConciergeViewedorDismissed({
            show: shouldShowFab,
            manuallyDismissed: false,
          })
        }
      }
    }

    handleScroll()
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [setShowFab, showFab, isOpened])

  const stickyFooterHeight =
    document.getElementById('sticky-footer')?.offsetHeight || 0
  const stickyFooterOffset = stickyFooterHeight + 22

  return (
    <div data-testid='floating-content'>
      <div className='d-block d-md-none'>
        <StickyControlled
          offset={stickyFooterOffset ?? DEFAULT_STICKY_FOOTER_OFFSET_MOBILE}
          className='mc-bg-transparent'
          show={showFab}
        >
          <FloatingAction />
        </StickyControlled>
      </div>

      <div className='d-none d-md-block'>
        <StickyControlled
          offset={stickyFooterOffset ?? DEFAULT_STICKY_FOOTER_OFFSET_DESKTOP}
          className='mc-bg-transparent'
          show={showFab}
        >
          <FloatingAction />
        </StickyControlled>
      </div>
    </div>
  )
}
